module.exports = __webpack_public_path__ + "static/media/81Bzm37TIaL._SL1500_.d8756f35.jpg";